// routes/_app.$usernameRaw_.follower.($subTab).tsx
import debug from 'debug'
import { userProfileHandle, userProfileLoader } from 'src/utils/router/route'
import { dynamic } from 'src/utils/ssr'
import { profileMeta, profileMetaLoader } from 'src/utils/ssr-meta/seo'
import type { Route } from './+types/_app.$usernameRaw_.follower.($subTab)'

const getClientModule = () =>
  import('src/clientRoutes/_app.$usernameRaw_.follower.($subTab)')
const log = debug('pixai:ssr-meta')

export const handle = userProfileHandle

export async function loader({ params, request }: Route.LoaderArgs) {
  const { parseUsername } = await import('src/utils/ssr-meta/url.server')
  const { fetchUserForSSR } =
    await import('src/utils/ssr-meta/graphql/user.server')
  const { getSeoConfig } = await import('src/utils/ssr-meta/consul.server')

  const usernameRaw = params.usernameRaw
  if (!usernameRaw) {
    return profileMetaLoader({ requestUrl: request.url })
  }

  const username = parseUsername(usernameRaw)
  if (!username) {
    return profileMetaLoader({ requestUrl: request.url })
  }

  const [user, seoConfig] = await Promise.all([
    fetchUserForSSR(username),
    getSeoConfig(),
  ])

  if (!user) {
    return profileMetaLoader({ requestUrl: request.url })
  }

  // Noindex users with fewer than configured follower threshold (save crawl budget)
  const followerCount = user.followerCount ?? 0
  if (followerCount < seoConfig.userIndexedMinimalFollowers) {
    log(
      'follower page loader noindex (low followers) username=%s followers=%s url=%s',
      username,
      followerCount,
      request.url,
    )
    return {
      ...profileMetaLoader({ requestUrl: request.url }),
      noIndex: true,
    }
  }

  return profileMetaLoader({ requestUrl: request.url })
}

export function meta({ loaderData }: Route.MetaArgs) {
  return profileMeta(loaderData)
}

export async function clientLoader(args: Route.ClientLoaderArgs) {
  return userProfileLoader({
    ...args,
    params: { ...args.params, tab: 'follower' },
  })
}
clientLoader.hydrate = true

export default dynamic(getClientModule, { ssr: false })
